<template>
  <div v-if="showForm">
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div class="column">
        <b-form class="col-xs-12">
          <b-form-text id="itemStartDateInputLiveHelp"> De * </b-form-text>
          <b-form-input
            v-model="START_DATE"
            aria-describedby="itemStartDateInputLiveHelp"
            type="date"
            size="sm"
            :state="startDateState"
          >
          </b-form-input>
          <b-form-input
            v-model="START_TIME"
            aria-describedby="itemStartDateInputLiveHelp itemStartTimeInputLiveFeedback"
            type="time"
            size="sm"
            :state="startTimeState"
          >
          </b-form-input>
          <b-form-text id="itemEndDateInputLiveHelp"> Até * </b-form-text>
          <b-form-input
            v-model="END_DATE"
            aria-describedby="itemEndDateInputLiveHelp"
            type="date"
            size="sm"
            :state="endDateState"
          >
          </b-form-input>
          <b-form-input
            v-model="END_TIME"
            aria-describedby="itemEndDateInputLiveHelp itemEndTimeInputLiveFeedback"
            type="time"
            size="sm"
            :state="endTimeState"
          >
          </b-form-input>
          <b-form-text id="title-sensor_id">
            Unidade do eixo esquerdo:</b-form-text
          >
          <b-form-select
            size="sm"
            v-model="unitSelectedA"
            :options="unit_options"
            placeholder="Selecione uma unidade"
          >
            <option disabled value="">Selecione uma unidade</option>
          </b-form-select>
          <div v-if="unitSelectedA.length > 0">
            <b-btn
              block
              size="sm"
              squared
              @click="openEquipments('left')"
              variant="orange"
              >Eixo esquerdo ({{ axeLeft.length }} de
              {{ optAxeLeft.length }})</b-btn
            >

            <div class="selected-box">
              <div
                class="selected-item"
                v-for="(a, index) in axeLeft"
                :key="index"
              >
                {{ a.NAME }}
              </div>
            </div>
          </div>

          <b-link v-if="!auxAxe" @click="auxAxe = true"
            >Adicionar eixo direito?</b-link
          >
          <div v-show="auxAxe">
            <b-form-text id="title-sensor_id">
              Unidade do eixo direito:</b-form-text
            >
            <b-form-select
              v-show="auxAxe"
              size="sm"
              v-model="unitSelectedB"
              :options="unit_options"
            >
              <option disabled value="">Selecione uma unidade</option>
            </b-form-select>
          </div>

          <b-btn
            v-if="unitSelectedB.length > 0"
            v-show="auxAxe"
            block
            size="sm"
            squared
            @click="openEquipments('right')"
            variant="orange"
            >Eixo direito ({{ axeRight.length }} de
            {{ optAxeRight.length }})</b-btn
          >

          <div
            class="selected-box"
            v-if="unitSelectedB.length > 0"
            v-show="auxAxe"
          >
            <div
              class="selected-item"
              v-for="(b, index) in axeRight"
              :key="index"
            >
              {{ b.NAME }}
            </div>
          </div>

          <b-btn
            block
            ref="formSearchBtn"
            variant="primary"
            @click="checkForm"
            v-show="axeLeft.length"
          >
            Buscar dados
          </b-btn>
        </b-form>
      </div>
      <b-modal
        ref="formError"
        no-close-on-backdrop
        centered
        hide-header
        hide-footer
        size="sm"
        body-bg-variant="warning"
      >
        <h5>Atenção!</h5>
        <div class="row">
          <div class="col-xs-12">
            Não é possível realizar a busca de dados porque
          </div>
          <div class="col-xs-3 center-xs">
            <alert-icon title="" style="font-size: 3em" />
          </div>
          <ul class="col-xs-9">
            <li v-for="err in errors" :key="err">{{ err }}</li>
          </ul>
        </div>
        <b-btn
          v-if="$refs.formError"
          block
          variant="light"
          size="sm"
          @click="$refs.formError.hide"
          >Vou corrigir</b-btn
        >
      </b-modal>
      <b-modal ref="formEquipments" centered hide-header hide-footer size="sm">
        <h6>
          Equipamentos ({{
            tableType == "left" ? axeLeft.length : axeRight.length
          }}
          selecionados)
        </h6>
        <div class="equipment-table">
          <div v-if="showEqp" class="col-xs-12 center-xs w-100 mt-2">
            <spinner />
            <span> Aguarde...</span>
          </div>
          <div v-else>
            <b-table
              striped
              small
              borderless
              hover
              responsive
              :items="equipments"
              :fields="fields"
            >
              <template slot="HEAD_CHECK">
                <b-form-checkbox
                  v-if="tableType == 'left'"
                  @click.native.prevent="toggleAll(tableType)"
                  v-model="allASelected"
                />
                <b-form-checkbox
                  v-else-if="tableType == 'right'"
                  @click.native.prevent="toggleAll(tableType)"
                  v-model="allBSelected"
                />
              </template>
              <template slot="CHECK" slot-scope="row">
                <b-form-checkbox
                  v-if="tableType == 'left'"
                  :value="row.item"
                  v-model="axeLeft"
                />
                <b-form-checkbox
                  v-else-if="tableType == 'right'"
                  :value="row.item"
                  v-model="axeRight"
                />
              </template>
              <template v-if="tableType == 'left'" slot="HEAD_OPT">
                {{ optAxeLeft.length }}
                {{ optAxeLeft.length == 1 ? "opção" : "opções" }}
              </template>
              <template v-else-if="tableType == 'right'" slot="HEAD_OPT">
                {{ optAxeRight.length }}
                {{ optAxeRight.length == 1 ? "opção" : "opções" }}
              </template>
              <template slot="OPT" slot-scope="row">
                <div>
                  <strong
                    >{{ typeof row.item.NAME == "number" ? "DIR " : ""
                    }}{{ row.item.NAME }}</strong
                  >
                </div>
                <div style="font-size: 10px">
                  {{ row.item.TYPE }} ({{ row.item.UNIT }})
                </div>
              </template>
            </b-table>
          </div>
        </div>
        <b-btn
          v-if="$refs.formEquipments"
          block
          size="sm"
          @click="$refs.formEquipments.hide"
          >Voltar</b-btn
        >
      </b-modal>
      <footer id="footer">
        <b-btn size="sm" block @click="$emit('close-form')"> Fechar </b-btn>
      </footer>
    </div>
  </div>
</template>

<script>
import { reports } from "@/api";
import { isMobile } from "@/pages/components/helpers.js";
export default {
  name: "report-form",
  props: {
    showForm: Boolean,
    eqps: Array,
    showEqp: Boolean,
  },
  created() {
    this.loadUnits();
  },
  data() {
    return {
      controller: null,
      //form
      START_DATE: "",
      START_TIME: "",
      END_DATE: "",
      END_TIME: "",
      axeLeft: [],
      axeRight: [],

      tableType: "",
      equipments: [], //filtered based by axe
      unit_options: [],
      auxAxe: false,
      unitSelectedA: "",
      unitSelectedB: "",
      allASelected: false,
      allBSelected: false,
      optAxeLeft: [],
      optAxeRight: [],
      fields: [
        {
          key: "CHECK",
        },
        {
          key: "OPT",
        },
      ],
      errors: [],
    };
  },
  watch: {
    unitSelectedA() {
      this.filterAxeLeftOptions();
    },
    unitSelectedB() {
      this.filterAxeRightOptions();
    },
    axeLeft() {
      this.allASelected = !!(
        this.axeLeft.length && this.axeLeft.length == this.optAxeLeft.length
      );
    },
    axeRight() {
      this.allBSelected = !!(
        this.axeRight.length && this.axeRight.length == this.optAxeRight.length
      );
    },
    optAxeLeft() {
      this.allASelected = !!(
        this.axeLeft.length && this.axeLeft.length == this.optAxeLeft.length
      );
    },
    optAxeRight() {
      this.allBSelected = !!(
        this.axeRight.length && this.axeRight.length == this.optAxeRight.length
      );
    },
  },
  computed: {
    startDateState() {
      return !!this.START_DATE;
    },
    startTimeState() {
      return !!this.START_TIME;
    },
    endDateState() {
      return !!this.END_DATE;
    },
    endTimeState() {
      return !!this.END_TIME;
    },
  },
  methods: {
    loadUnits() {
      this.unit_options = this.eqps
        .filter((e, i, arr) => arr.findIndex((x) => x.UNIT === e.UNIT) === i)
        .map((e) => ({
          value: e.UNIT,
          text: e.UNIT,
        }));

      const pluv = this.unit_options.find((e) => e.value === "mm");

      if (pluv) {
        this.unit_options.push({
          value: "mm:per_reading",
          text: `${pluv.text} (por leitura)`,
        });
      }

      this.optAxeLeft = this.eqps.filter((e) => e.UNIT == this.unitSelectedA);
      this.optAxeRight = this.eqps.filter((e) => e.UNIT == this.unitSelectedB);
      switch (this.tableType) {
        case "left":
          this.equipments = this.optAxeLeft;
          break;
        case "right":
          this.equipments = this.optAxeRight;
          break;
        default:
          this.equipments = [];
          break;
      }
    },
    isMobile(ref) {
      return isMobile(ref);
    },
    checkForm() {
      this.errors = [];
      let START = `${this.START_DATE} ${this.START_TIME}`;
      let END = `${this.END_DATE} ${this.END_TIME}`;

      if (!this.START_DATE) this.errors.push("Data inicial vazio");
      if (!this.START_TIME) this.errors.push("Hora inicial vazio");
      if (!this.END_DATE) this.errors.push("Data final vazio");
      if (!this.END_TIME) this.errors.push("Hora final vazio");
      if (START.trim() && END.trim()) {
        if (START > END)
          this.errors.push(
            "Data-hora inicial não pode ser posterior à data-hora final",
          );
        else if (START == END)
          this.errors.push(
            "Data-hora inicial não pode ser igual à data-hora final",
          );
      }
      if (this.errors.length) this.$refs.formError.show();
      else {
        this.$emit("chart-data", {
          START,
          END,
          axeLeft: this.organizeAxe("left", this.axeLeft, this.unitSelectedA),
          axeRight: this.organizeAxe(
            "right",
            this.axeRight,
            this.unitSelectedB,
          ),
        });
        this.$emit("close-form");
      }
    },
    organizeAxe(x, list, unit_selected) {
      let arr = [];
      for (let i = 0; i < list.length; i++) {
        let column = "";

        let types = ["VOLUME", "VAZÃO", "BATERIA", "SINAL"];
        let columns = ["VOL", "FLOW", "BAT", "ACK"];

        if (list[i].EQP != "SENSOR") {
          let index = types.indexOf(list[i].TYPE);
          if (index > -1) column = columns[index];
        }
        arr.push({
          EQP: list[i].EQP,
          NAME: list[i].NAME,
          COLUMN: column,
          CONDITION: {
            UNITS: [list[i].UNIT === "mm:per_reading" ? "mm" : list[i].UNIT],
            TYPES: [list[i].TYPE],
            PER_READING: unit_selected === "mm:per_reading", // ← flag
          },
        });
      }
      return arr.sort();
    },
    filterAxeLeftOptions() {
      this.axeLeft = [];
      const unit =
        this.unitSelectedA === "mm:per_reading" ? "mm" : this.unitSelectedA;
      this.optAxeLeft = this.eqps.filter((e) => e.UNIT == unit);
    },
    filterAxeRightOptions() {
      this.axeRight = [];
      const unit =
        this.unitSelectedB === "mm:per_reading" ? "mm" : this.unitSelectedB;
      this.optAxeRight = this.eqps.filter((e) => e.UNIT == unit);
    },
    openEquipments(axe) {
      this.tableType = axe;
      switch (axe) {
        case "left":
          this.equipments = this.optAxeLeft;
          break;
        case "right":
          this.equipments = this.optAxeRight;
          break;
        default:
          this.equipments = [];
          break;
      }
      this.$refs.formEquipments.show();
    },
    cancelPendingRequestIfExists() {
      this.controller.abort();
    },
    toggleAll(axe) {
      if (axe == "left") {
        this.allASelected = !this.allASelected;
        if (this.axeLeft.length < this.optAxeLeft.length) {
          this.axeLeft = this.optAxeLeft.slice();
        } else if (this.axeLeft.length == this.optAxeLeft.length) {
          this.axeLeft = [];
        }
      } else if (axe == "right") {
        this.allBSelected = !this.allBSelected;
        if (this.axeRight.length < this.optAxeRight.length) {
          this.axeRight = this.optAxeRight.slice();
        } else if (this.axeRight.length == this.optAxeRight.length) {
          this.axeRight = [];
        }
      }
    },
    loadEquipments() {
      this.controller = new AbortController();
      if (this.form.PROPERTY.equipment == "dir") this.loadDirs();
      else if (this.form.PROPERTY.equipment == "sensor") this.loadSensors();
      else if (this.form.PROPERTY.equipment == "valve") this.loadActuators();
      else if (this.form.PROPERTY.equipment == null)
        this.loadingLogOptions = false;
    },
    loadActuators() {
      this.requestOpen = true;
      reports
        .getActuators(this.controller)
        .then((ret) => {
          this.eqps = ret.length ? ret.filter((e) => !!e.NAME) : [];
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro ao buscar atuadores.");
          // this.retryEquipments = true;
          return;
        })
        .then((_) => {
          this.requestOpen = false;
          this.loadingLogOptions = false;
        })
        .catch((e) => {
          return;
        });
    },
    loadDirs() {
      this.requestOpen = true;
      reports
        .getDirs(this.controller)
        .then((ret) => {
          this.eqps = ret.length ? ret.filter((e) => !!e.NAME) : [];
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro ao buscar dirs.");
          // this.retryEquipments = true;
          return;
        })
        .then((_) => {
          this.requestOpen = false;
          this.loadingLogOptions = false;
        })
        .catch((e) => {
          return;
        });
    },
    loadSensors() {
      this.requestOpen = true;
      reports
        .getSensors(this.controller)
        .then((ret) => {
          this.eqps = ret.length ? ret.filter((e) => !!e.NAME) : [];
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro ao buscar sensores.");
          // this.retryEquipments = true;
          return;
        })
        .then((_) => {
          this.requestOpen = false;
          this.loadingLogOptions = false;
        })
        .catch((e) => {
          return;
        });
    },
  },
};
</script>

<style scoped>
.equipment-table {
  height: 310px !important;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
